var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',_vm._g(_vm._b({staticClass:"font-bold",attrs:{"type":"border","icon-pack":"nucleo","icon":"nucleo-file-download-94-2"}},'vs-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.btnText))])}
var staticRenderFns = []

export { render, staticRenderFns }